// src/pages/CloserWindow.jsx
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function CloserWindow() {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('단창용');

    // Assuming similar tab structure for now; user can request specific tabs later.
    const tabList = [
        '단창용',
        '대형창문용',
        '다연창용',
        '슬라이딩 단창용',
        '슬라이딩 이중창용',
        '전, 수동 환기창용',
        '천장, 경사각의 창문용'
    ];

    return (
        <div className="text-gray-800">
            {/* 배경 이미지 Hero 섹션 */}
            <section className="relative h-[60vh] bg-[url('hero-bg.jpg')] bg-cover bg-center flex items-center justify-center">
                <div className="absolute inset-0 bg-black bg-opacity-50" />
                <div className="relative z-10 text-center px-4 flex flex-col justify-center h-full">
                    <h1 className="text-4xl md:text-5xl font-bold text-white">제품소개</h1>
                    <p className="mt-4 text-white text-lg md:text-xl">JDWinTech의 대표 제품들을 소개합니다.</p>

                    {/* 하단 탭 메뉴 */}
                    <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-40 flex justify-center">
                        <div className="flex">
                            <Link to="/products/smoke" className={`rounded-tl-md px-6 py-3 text-sm md:text-base font-medium ${location.pathname === '/products/smoke' ? 'bg-white text-blue-800' : 'text-white hover:bg-white hover:text-blue-800'}`}>배연창</Link>
                            <Link to="/products/vent" className={`px-6 py-3 text-sm md:text-base font-medium ${location.pathname === '/products/vent' ? 'bg-white text-blue-800' : 'text-white hover:bg-white hover:text-blue-800'}`}>환기창</Link>
                            <Link to="/products/closer" className={`rounded-tr-md px-6 py-3 text-sm md:text-base font-medium ${location.pathname === '/products/closer' ? 'bg-white text-blue-800' : 'text-white hover:bg-white hover:text-blue-800'}`}>창문형 자동폐쇄장치</Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* 제품 설명 섹션 */}
            <section className="py-20 px-4 md:px-20 max-w-6xl mx-auto">
                <h2 className="text-2xl font-bold text-blue-800 mb-6 text-center">창문형 자동폐쇄장치</h2>

                {/* 탭 버튼 */}
                <div className="inline-flex justify-center overflow-hidden rounded-md border border-gray-300 mb-10">
                    {tabList.map((label) => (
                        <button
                            key={label}
                            onClick={() => setActiveTab(label)}
                            className={`px-6 py-3 text-sm md:text-base font-medium min-w-[150px] text-gray-700 hover:bg-gray-100 focus:z-10 ${activeTab === label ? 'bg-indigo-800 text-white' : ''}`}
                        >
                            {label}
                        </button>
                    ))}
                </div>

                {tabList.map((label, idx) => (
                    activeTab === label && (
                        <div key={label} className="space-y-12">
                            {/* Reusing vent images/content structure as placeholder since 'similar' was requested */}
                            <img src={`/images/smoke/${idx + 1}.jpg`} alt={`${label} 이미지`} className="w-full max-w-3xl mx-auto mb-6 rounded shadow" />
                            {/* 기능 */}
                            <div className="text-center">
                                <h3 className="text-3xl font-bold text-gray-800 mb-2">기능</h3>
                                <p className="text-red-600 font-semibold mb-4">특허 등록 (제10-2175022호)</p>
                                <ul className="text-left list-disc pl-5 max-w-3xl mx-auto space-y-2">
                                    <li>화재 발생 시 자동 폐쇄</li>
                                    <li>평상시 환기 가능</li>
                                    <li>비상시 수동 조작 가능</li>
                                    <li>다양한 창호에 적용 가능</li>
                                </ul>
                            </div>

                            {/* 특장점 */}
                            <div>
                                <h3 className="text-3xl font-bold text-center text-gray-800 mb-8">특장점</h3>
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                                    {['신속한 자동 폐쇄', '안정적인 구동 성능', '간편한 설치 및 유지관리', '세련된 디자인'].map((text, i) => (
                                        <div key={i} className="text-center border p-6">
                                            <div className="mb-4 h-12 bg-gray-200" />
                                            <p>{text}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* 도입배경 */}
                            <div>
                                <h3 className="text-3xl font-bold text-center text-gray-800 mb-8">도입배경</h3>
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                                    {['소방 관련 법규 강화', '고층 건물 화재 안전성 증대 필요', '기존 폐쇄장치의 오작동 문제', '건물 미관 고려'].map((text, i) => (
                                        <div key={i} className="text-center border p-6">
                                            <div className="mb-4 h-12 bg-gray-200" />
                                            <p>{text}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* 도입효과 */}
                            <div className="text-center">
                                <h3 className="text-3xl font-bold text-gray-800 mb-8">도입효과</h3>
                                <ul className="text-left list-disc pl-5 max-w-3xl mx-auto space-y-2">
                                    <li>화재 확산 방지 및 인명 피해 최소화</li>
                                    <li>건물 안전 등급 향상</li>
                                    <li>유지보수 비용 절감</li>
                                    <li>사용자 편의성 증대</li>
                                </ul>
                            </div>

                            {/* 도입사례 */}
                            <div>
                                <h3 className="text-3xl font-bold text-center text-gray-800 mb-8">도입사례</h3>
                                <div className="h-64 bg-gray-200 rounded shadow-md max-w-4xl mx-auto" />
                            </div>

                            {/* 활용방안 */}
                            <div>
                                <h3 className="text-3xl font-bold text-center text-gray-800 mb-8">활용방안</h3>
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                                    {['오피스텔 및 주상복합', '학교 및 관공서', '병원 및 요양시설', '다중이용업소'].map((text, i) => (
                                        <div key={i} className="text-center border p-6">
                                            <div className="mb-4 h-12 bg-gray-200" />
                                            <p>{text}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    )
                ))}
            </section>
        </div>
    );
}

export default CloserWindow;
